<template>
  <div style="padding: 20px;">
    <div style="margin-bottom: 30px;">aqui va la invitacion</div>
    <qriously :value="id" :size="400" />
  </div>
</template>

<script>
import Vue from "vue";
import VueQriously from "vue-qriously";
Vue.use(VueQriously);

export default {
  name: "Invitation",
  data: () => ({
    id: ""
  }),
  mounted() {
    var query = this.$route.query;
    this.id = query.id;
  }
};
</script>